"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  'Add "{inputValue}"': ['Добавить "', ["inputValue"], '"'],
  "All items have been removed.": "Все элементы удалены.",
  "Clear selection": "Отменить выбор",
  "No results found.": "Результатов не найдено",
  "Press Enter to select or deselect an option.": "Нажмите Enter, чтобы выбрать опцию или отменить её выбор.",
  "Select All": "Выбрать всё",
  "Selected Items": "Выбранные элементы",
  "Toggle menu": "Меню раскрывающегося списка",
  "listbox contents": "Содержимое поля списка",
  "{itemAsString} has been removed.": ["Элемент (", ["itemAsString"], ") удалён."],
  "{itemAsString} has been selected.": ["Элемент (", ["itemAsString"], ") выбран."],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["Доступен ", "#", " результат"],
    other: ["Доступно результатов: ", "#"]
  }], ", для навигации используйте клавиши со стрелками вверх и вниз, для выбора — клавишу Enter. Для выбора нажмите клавишу Enter."],
  "{selectedValue} selected": ['Выбран элемент "', ["selectedValue"], '"'],
  "{totalSelectedItems} selected": ["Выбрано элементов: ", ["totalSelectedItems"]],
  "{totalSelectedItems} selected. Deselect all": ["Выбрано элементов: ", ["totalSelectedItems"], ". Отменить выделение"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": ["Выбрано элементов: ", ["totalSelectedItems"], ". Выбрать все элементы (", ["totalOptions"], ")"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map